import { render } from "./ViewStaffModal.vue?vue&type=template&id=62f37a92&scoped=true"
import script from "./ViewStaffModal.vue?vue&type=script&lang=js"
export * from "./ViewStaffModal.vue?vue&type=script&lang=js"

import "./ViewStaffModal.vue?vue&type=style&index=0&id=62f37a92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f37a92"]])

export default __exports__